import OnlineCard from '../../components/cards/OnlineCard'
import typo from "../../typography.module.css"
import styles from "../Dashboard.module.css"

const DashboardMedia = ({ user }) => {
    return (
        <div className={styles.section}>
            <div className={styles.sectionInner}>
                <div className={typo.title}>Benvenuto, {user.name}</div>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                    <OnlineCard />
                </div>
            </div>
        </div>
    )
}

export default DashboardMedia
